module.exports = __webpack_public_path__ + "static/media/bathroom_tub.ff36102a.jpg";